export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";